<script lang="ts">
    import FeatherIcon from 'svelte-feather-icon'
    import { Col, Input, Row } from 'sveltestrap'
    import { Searcharticles } from '../../../utils/Constant/Constant'
    import Card from '../../Core/Card.svelte'
    import LatestUpdates from './LatestUpdates.svelte'
    import Navigation from './Navigation.svelte'
</script>
  
<Col xl="4" lg="6" md="5" class="xl-40">
  <Row>
    <Col lg="12">
      <Card
        cardProps="card-mb-faq xs-mt-search"
        cardHeaderprops="faq-header"
        cardBodyprops="faq-body">
        <div slot="customheader">
          <h5 class="ps-0">{Searcharticles}</h5>
          <FeatherIcon icon="help-circle" />
        </div>
        <div slot="contentbody">
          <div class="faq-form">
            <Input type="text" placeholder="Search.." />
            <FeatherIcon class="search-icon" icon="search" />
          </div>
        </div>
      </Card>
    </Col>
    <Navigation />
    <LatestUpdates />
  </Row>
</Col>
  